import { lazy } from "react";

import ClientPortalLayout from "./components/layout";

const ClientTransactionSuccessPage = lazy(
  () => import("./modules/transaction/success"),
);
const Pay = lazy(() => import("./modules/invoice/pay"));
const StripePaymentStatus = lazy(
  () => import("./modules/invoice/stripe-payment-status"),
);

const routes = [
  {
    path: "",
    element: <ClientPortalLayout />,
    children: [
      {
        path: "invoice/:code/pay",
        element: <Pay />,
      },
      {
        path: "invoice/:code/success",
        element: <ClientTransactionSuccessPage />,
      },
      {
        path: "invoice/:code/stripe-payment-status",
        element: <StripePaymentStatus />,
      },
    ],
  },
];

export default routes;
